<div
  matRipple
  class="flex flex-row justify-center items-center gap-3 h-12 bg-white rounded-xl shadow-green/08 cursor-pointer"
>
  <img class="h-6" [src]="icon()" [alt]="label()" />
  <p class="text-caption-regular text-gray-dark">{{ label() }}</p>
</div>
